export default [
  {
    path: 'crewing',
    component: () => import('../../../views/app/logistics/crewing/index.vue')
  }
]
